import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useDecorativeIconMotion } from '../../primitives/useIconMotion.js';
import type { AnimatedIconProps } from '../../primitives/types.js';

/** Info — circle with `i`. The dot pulses gently to indicate "more
 *  context available" (used as a Tooltip / HoverCard trigger). */
export function IcnInfo(props: AnimatedIconProps): ReactNode {
  const { active = true, ...rest } = props;
  const animate = useDecorativeIconMotion(active);
  return (
    <Svg {...rest} iconName="info" data-on={active ? 'true' : 'false'}>
      <circle cx="8" cy="8" r="6" />
      <path d="M8 7v4" />
      <circle cx="8" cy="5" r="0.6" fill="currentColor" stroke="none">
        {animate && (
          <animate
            attributeName="r"
            values="0.6;0.9;0.6"
            dur="2s"
            repeatCount="indefinite"
          />
        )}
      </circle>
    </Svg>
  );
}
